import { combineReducers } from "redux";
import testRedux from "./testRedux";
import booleanReducer from "./dataHasBeenChanged.js";
import {
  incrementIndexForNotification,
  setTotalNotificationsReducer,
  totalNotificaitonReducer,
} from "./notificationReducer.tsx";
import restaurantTypewriterReducer from "./restaurantTypewriterReducer";
import kitchenReducer from "./kitchenReducer.js";

const rootReducers = combineReducers({
  testRedux: testRedux,
  totalNotification: totalNotificaitonReducer,
  notifications: setTotalNotificationsReducer,
  index: incrementIndexForNotification,
  typewriter: restaurantTypewriterReducer,
  booleanState: booleanReducer,
  kitchenReducer: kitchenReducer,
});

export default rootReducers;
